<template lang="pug">
  component(
    :is="htmlTag"
    :class="[buttonClass, customClasses]"
    v-on="$listeners"
    :disabled="disabled"
    :aria-label="label"
  )
    icon(v-if="icon", :name="icon", :size="size")
    span.button__content(v-else)
      slot {{ label }}
      span(v-if="arrowLink")
        icon(name="arrow-right", size="11px")
</template>

<script>
  import Icon from 'scripts/components/basic/Icon.vue';

  export default {
    name: 'VButton',
    components: { Icon },
    props: {
      label: String,
      customClasses: String,
      htmlTag: {
        type: String,
        default: 'button',
      },
      primary: {
        type: Boolean,
        default: false,
      },
      secondary: {
        type: Boolean,
        default: false,
      },
      secondaryAlternate: {
        type: Boolean,
        default: false,
      },
      tertiary: {
        type: Boolean,
        default: false,
      },
      arrow: {
        type: Boolean,
        default: false,
      },
      animate: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      icon: {
        type: String,
      },
      size: {
        type: String,
      },
      arrowLink: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      buttonClass() {
        return {
          'btn btn--primary': this.primary === true,
          'btn btn--secondary': this.secondary === true,
          'btn btn--secondary alternate': this.secondaryAlternate === true,
          'btn btn--tertiary': this.tertiary === true,
          'btn--arrow': this.arrow === true,
          'btn--animate hvr-sweep-to-top': this.animate === true,
          'btn--link-arrow': this.arrowLink === true,
        };
      },
    },
  };
</script>

<style scoped lang="scss"></style>
